import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export interface OperationalProject {
  id: string;
  code: string;
  name_en: string;
  name_ar: string | null;
  primary_city: string | null;
  status: string;
}

/**
 * PR MAY10 P4B-POLISH (A.6) — operational projects list, used by the
 * Project picker on Vehicle and Driver edit forms.
 */
export function useOperationalProjects() {
  return useQuery({
    queryKey: ['operational-projects'],
    queryFn: async () => {
      const r = await apiClient.get<{ items: OperationalProject[] }>('/api/v1/projects');
      return r.data.items;
    },
    staleTime: 5 * 60 * 1000,
  });
}
